import { render } from "./MassHostNotificationsDisable.vue?vue&type=template&id=565fa564"
import script from "./MassHostNotificationsDisable.vue?vue&type=script&lang=js"
export * from "./MassHostNotificationsDisable.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__